import { useDashboardData } from '@/hooks/useDashboardData'
import { Trophy, Target, Zap, Shield } from 'lucide-react'

const SummaryCards = () => {
  const { data, isLoading, error } = useDashboardData()

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
        {[1, 2, 3].map((i) => (
          <div key={i} className="bg-white p-4 lg:p-6 rounded-lg shadow animate-pulse">
            <div className="h-4 bg-gray-200 rounded mb-2"></div>
            <div className="h-8 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>
    )
  }

  if (error || !data) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <p className="text-red-800">データの読み込みに失敗しました</p>
      </div>
    )
  }

  const { summary } = data

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 sm:gap-3 lg:gap-6">
      {/* 総試合数 */}
      <div className="bg-white p-2 sm:p-3 lg:p-6 rounded-lg shadow">
        <div className="flex items-center">
          <div className="p-2 bg-blue-100 rounded-lg">
            <Trophy className="h-4 w-4 sm:h-5 sm:w-5 lg:h-6 lg:w-6 text-blue-600" />
          </div>
          <div className="ml-2 sm:ml-3 lg:ml-4">
            <p className="text-xs lg:text-sm font-medium text-gray-600">総試合数</p>
            <p className="text-base sm:text-lg lg:text-2xl font-bold text-gray-900">
              {summary.totalMatches.toLocaleString()}
            </p>
          </div>
        </div>
      </div>

      {/* 総ゴール数 */}
      <div className="bg-white p-2 sm:p-3 lg:p-6 rounded-lg shadow">
        <div className="flex items-center">
          <div className="p-2 bg-green-100 rounded-lg">
            <Target className="h-4 w-4 sm:h-5 sm:w-5 lg:h-6 lg:w-6 text-green-600" />
          </div>
          <div className="ml-2 sm:ml-3 lg:ml-4">
            <p className="text-xs lg:text-sm font-medium text-gray-600">総ゴール数</p>
            <p className="text-base sm:text-lg lg:text-2xl font-bold text-gray-900">
              {summary.totalGoals.toLocaleString()}
            </p>
          </div>
        </div>
      </div>

      {/* PK戦総数 */}
      <div className="bg-white p-2 sm:p-3 lg:p-6 rounded-lg shadow">
        <div className="flex items-center">
          <div className="p-2 bg-purple-100 rounded-lg">
            <Zap className="h-4 w-4 sm:h-5 sm:w-5 lg:h-6 lg:w-6 text-purple-600" />
          </div>
          <div className="ml-2 sm:ml-3 lg:ml-4">
            <p className="text-xs lg:text-sm font-medium text-gray-600">PK戦総数</p>
            <p className="text-base sm:text-lg lg:text-2xl font-bold text-gray-900">
              {summary.totalPkMatches.toLocaleString()}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SummaryCards
